module.exports = __webpack_public_path__ + "src/assets/img/show_car_off.84ef392a.svg";